<script setup lang="ts">
import { useBoardDialogStore } from '@/stores/boardDialogStore';
import { mockData } from '../mock';
import { useDialogStore } from '@/stores/dialogStore';

const boardDialogStore = useBoardDialogStore();
const boardOption = computed(() => boardDialogStore.boardDialogOption);

const confirmStore = useDialogStore();
const handleClose = () => {
  console.log('read close');
  boardDialogStore.closeBoardDialog();
};

const handleMoreMenuClick = () => {
  console.log('handleMoreMenuClick');
};
const handleUpdateClick = () => {
  console.log('handleUpdateClick');
  handleClose();
  boardDialogStore.openBoardDialog({ type: 'update' });
};
const handleDeleteClick = () => {
  console.log('handleDeleteClick');
  handleClose();
  confirmStore.openConfirm({
    title: '삭제하시겠습니까?',
    message: '삭제하시면 복구가 불가능합니다.',
    buttonText: '삭제',
    callback: () => {
      console.log('삭제클릭 로직 넣기');
      //TODO:
    },
  });
};

const items = [
  { title: '수정하기', handler: handleUpdateClick },
  { title: '삭제하기', handler: handleDeleteClick },
];

onMounted(() => {
  console.log('read mounted');
});
</script>

<template>
  <div class="title-row">
    <v-card-title class="card__title">
      {{ 'Q.' + mockData.question }}
    </v-card-title>

    <v-menu :location="'end'">
      <template v-slot:activator="{ props }">
        <VIcon
          class="title-row__icon"
          icon="ri-more-2-line"
          size="22"
          v-bind="props"
          @click="handleMoreMenuClick"
        />
      </template>
      <v-list>
        <v-list-item
          v-for="(item, index) in items"
          :key="index"
          :value="item.title"
          @click="item.handler"
        >
          <v-list-item-title>{{ item.title }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </div>
  <v-divider style="width: 200%" />
  <v-card-title class="card__title"> {{ mockData.answer ? 'A.' : '답변 대기중입니다' }}</v-card-title>
  <v-card-text
    v-if="mockData.answer"
    class="card__text"
  >
    {{ mockData.answer }}
  </v-card-text>

  <v-card-actions class="card__action pb-5">
    <v-btn
      :text="'확인'"
      @click="handleClose"
      color="white"
    ></v-btn>
  </v-card-actions>
</template>

<style lang="scss" scoped>
@import '@/@core/scss/base/_mixins.scss';
@import '@/@core/scss/base/_variables.scss';

.title-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  &__icon {
    flex: 0.5;
    width: 100%;
    border: 1px solid black;
  }
}
.card {
  &__title {
    flex: 9.5;
    width: 100%;
    font-size: 1.3rem;
    font-weight: 800;
    padding: 1rem;
    white-space: pre-wrap;
    word-break: keep-all;
    /* background-color: red; */
  }
  &__text {
    /* background-color:yellow; */
    /* margin-top: 10px; */
    font-size: 1rem;
    width: 100%;
    white-space: pre-wrap;
    word-break: keep-all;
  }
  &__action {
    justify-content: center;
    width: 100%;
    padding-top: 20px;
    > button {
      width: 20%;
      background-color: #6c5ce7;
      @include respond-to(smartphone) {
        width: 30%;
      }
    }
  }
}
</style>
